import { useState } from 'react';
import SupplierLayout from '../../components/layout/SupplierLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Users, UserPlus, Shield } from 'lucide-react';
import { useSupplierAuth } from '../../context/SupplierAuthContext';

const SupplierUsersPage = () => {
  const { user } = useSupplierAuth();

  return (
    <SupplierLayout>
      <div className="space-y-6" data-testid="supplier-users-page">
        <div>
          <h1 className="text-xl font-bold text-black tracking-tight">Gebruikersbeheer</h1>
          <p className="text-sm text-neutral-500 mt-1">Beheer de gebruikers van uw leveranciersorganisatie</p>
        </div>

        <Card className="border-neutral-200 shadow-sm">
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-bold text-black flex items-center gap-2">
              <Users className="h-4 w-4" strokeWidth={1.5} />
              Teamleden
            </CardTitle>
            <CardDescription className="text-xs text-neutral-500">Huidige gebruikers met toegang tot het leveranciersportaal</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-neutral-200">
                    <th className="p-3 text-left text-[10px] font-bold uppercase tracking-wider text-neutral-500 bg-neutral-50">Naam</th>
                    <th className="p-3 text-left text-[10px] font-bold uppercase tracking-wider text-neutral-500 bg-neutral-50">E-mail</th>
                    <th className="p-3 text-left text-[10px] font-bold uppercase tracking-wider text-neutral-500 bg-neutral-50">Rol</th>
                    <th className="p-3 text-left text-[10px] font-bold uppercase tracking-wider text-neutral-500 bg-neutral-50">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-neutral-100">
                    <td className="p-3 text-sm text-black font-medium">{user?.name || user?.email}</td>
                    <td className="p-3 text-sm text-neutral-600">{user?.email}</td>
                    <td className="p-3"><Badge className="bg-blue-100 text-blue-700 text-[10px] border-transparent">Beheerder</Badge></td>
                    <td className="p-3"><Badge className="bg-green-100 text-green-700 text-[10px] border-transparent">Actief</Badge></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>

        <Card className="border-amber-200 bg-amber-50/50 shadow-sm">
          <CardContent className="p-4 flex items-center gap-3">
            <div className="h-10 w-10 rounded-lg bg-amber-100 flex items-center justify-center shrink-0">
              <UserPlus className="h-5 w-5 text-amber-600" strokeWidth={1.5} />
            </div>
            <div>
              <p className="text-sm font-semibold text-amber-800">Extra gebruikers toevoegen</p>
              <p className="text-xs text-amber-700">De mogelijkheid om teamleden uit te nodigen en rollen toe te wijzen wordt binnenkort beschikbaar.</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </SupplierLayout>
  );
};

export default SupplierUsersPage;
